const isNumberInput = (el) => el instanceof HTMLInputElement && el.type === "number";

export function installNumberInputBehavior() {
  let keepSelection = false;

  // Focus follows this mousedown; remember that the mouse caused it
  document.addEventListener(
    "mousedown",
    (e) => {
      keepSelection = isNumberInput(e.target) && document.activeElement !== e.target;
    },
    true
  );

  // Select everything as soon as a number input gets focus (click or Tab)
  document.addEventListener("focusin", (e) => {
    if (isNumberInput(e.target)) e.target.select();
  });

  // The mouseup of the focusing click would otherwise drop the selection again
  document.addEventListener(
    "mouseup",
    (e) => {
      if (keepSelection && isNumberInput(e.target)) e.preventDefault();
      keepSelection = false;
    },
    true
  );

  // Without arrows, the mouse wheel over a focused field can still change the value
  document.addEventListener(
    "wheel",
    (e) => {
      if (isNumberInput(e.target) && document.activeElement === e.target) e.target.blur();
    },
    { passive: true }
  );
}